import { createSelectors } from "@/redux/helpers/selector";

import { MODULE } from "./constants";

export const [
  getLists,
  getSuppliersList,
  isFetchingSuppliersStatus,
  isFetchingPurchaseProductsStatus,
  isCreating,
  isGroupedProducts,
  hasFormSubmitted,
  getSelectedSupplierForAll,
  isCreatePurchaseOrderModalOpen,
  isCreatedPurchaseOrderModalOpen,
  isCreatingPurchaseOrderModalOpen,
  getSelectedProductUids,
  getCreatedPoUids,
] = createSelectors(MODULE, [
  "lists",
  "suppliersList",
  "isFetchingSuppliersStatus",
  "isFetchingPurchaseProductsStatus",
  "isCreating",
  "isGroupedProducts",
  "hasFormSubmitted",
  "selectedSupplierForAll",
  "isCreatePurchaseOrderModalOpen",
  "isCreatedPurchaseOrderModalOpen",
  "isCreatingPurchaseOrderModalOpen",
  "selectedProductUids",
  "createdPoUids",
]);

export const hasSelectedProduct = (state) => {
  const uids = getSelectedProductUids(state);
  return uids.length > 0;
};

export const isSelectedProductsHasSupplier = (state) => {
  const selectedProductUids = getSelectedProductUids(state);
  const lists = getLists(state);
  const products = lists.filter(
    (p) => selectedProductUids.includes(p.uid) && p.supplierForCreatedPo
  );
  return products.length === selectedProductUids.length;
};

export const areAllSelectableProductSelected = (state) => {
  const lists = getLists(state);
  const selectedProductUids = getSelectedProductUids(state);
  return lists.length === selectedProductUids.length;
};
